<template>
  <Card>
    <template #content>
      <div class="flex flex-col gap-y-7.5 items-center">
        <section class="text-center flex flex-col gap-y-5 items-center">
          <h1>
            <slot name="title" />
          </h1>

          <p class="leading-tight max-w-lg !px-5">
            <slot name="message" />
          </p>
        </section>

        <slot />
      </div>
    </template>
  </Card>
</template>
